<template>
    <section id="portfolio" class="portfolio_area pt-120">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-6">
          <div class="section_title text-center pb-60">
            <h4
              class="title wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s"
            >
              Nosso Espaço
            </h4>
            <!--<p
              class="wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.4s"
            >
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
              nonumy eirmod tempor invidunt labor dolore.
            </p>-->
          </div>
        </div>
      </div>
    </div>
    <div class="portfolio_wrapper d-flex flex-wrap">
      <div
        class="single_portfolio wow fadeInUp"
        data-wow-duration="1.3s"
        data-wow-delay="0.2s"
      >
        <img src="assets/images/ImgCDG/IMG_2021.jpg" alt="portfolio" />
        <!--<div class="portfolio_content">
          <ul class="meta">
            <li>
              <a href="#"><i class="lni lni-link"></i></a>
            </li>
          </ul>
          <h5 class="portfolio_title">Logo And Branding</h5>
        </div>-->
      </div>
      <div
        class="single_portfolio wow fadeInUp"
        data-wow-duration="1.3s"
        data-wow-delay="0.3s"
      >
        <img src="assets/images/ImgCDG/IMG_2024.jpg" alt="portfolio" />
        <!--<div class="portfolio_content">
          <ul class="meta">
            <li>
              <a href="#"><i class="lni lni-link"></i></a>
            </li>
          </ul>
          <h5 class="portfolio_title">Bootstrap 5 Project</h5>
        </div>-->
      </div>
      <div
        class="single_portfolio wow fadeInUp"
        data-wow-duration="1.3s"
        data-wow-delay="0.4s"
      >
        <img src="assets/images/ImgCDG/IMG_2523.jpg" alt="portfolio" />
        <!--<div class="portfolio_content">
          <ul class="meta">
            <li>
              <a href="#"><i class="lni lni-link"></i></a>
            </li>
          </ul>
          <h5 class="portfolio_title">Creative Projects</h5>
        </div>-->
      </div>
      <div
        class="single_portfolio wow fadeInUp"
        data-wow-duration="1.3s"
        data-wow-delay="0.5s"
      >
        <img src="assets/images/ImgCDG/IMG_2577.jpg" alt="portfolio" />
        <!--<div class="portfolio_content">
          <ul class="meta">
            <li>
              <a href="#"><i class="lni lni-link"></i></a>
            </li>
          </ul>
          <h5 class="portfolio_title">UI/UX Projects</h5>
        </div>-->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  //props: ['textconteudo', 'icon', 'title'],
};
</script>

<style scoped>

</style>